/**
 * Stateless Component for Footer Rendering
 * TODO: Have to change the year for copyright to automatically reflect current year
 */

import React from "react";
// import service from "../../utils/service";
import { BUSINESS_UNIT } from "../../utils/PreviousSession.constants";

function Footer(props) {
  const thriveImgSrc = "https://miappstorage.dev.cglcloud.in/api/miappstorage/v1/downloadImage/thrive.png";
  // React.useEffect(() => {
  //   service.getImageCode("thrive.jpeg", setThriveImgSrc)
  // }, []);

  return (
    <>
      <table
        align='center'
        width='800'
        style={{
          width: "800px",
          textAlign: "justify",
          borderCollapse: "separate",
          tableLayout: "'fixed'",
          fontFamily: "Helvetica, Arial, sans-serif",
        }}
      >
        <tbody>
          <tr>
            <td valign='middle'>
              <a href='https://twitter.com/Cargill' style={{ marginLeft: "10px", marginRight: "10px" }}>
                <img
                  src='https://miappstorage.dev.cglcloud.in/api/miappstorage/v1/downloadImage/twitterNew.png'
                  alt=''
                />
              </a>
            </td>
            <td valign='middle'>
              <a href='https://www.facebook.com/cargill' style={{ marginLeft: "10px", marginRight: "10px" }}>
                <img
                  src='https://miappstorage.dev.cglcloud.in/api/miappstorage/v1/downloadImage/facebookNew.png'
                  alt=''
                />
              </a>
            </td>
            <td valign='middle'>
              <a href='https://www.linkedin.com/company/cargill' style={{ marginLeft: "10px", marginRight: "10px" }}>
                <img
                  src='https://miappstorage.dev.cglcloud.in/api/miappstorage/v1/downloadImage/linkedinNew.png'
                  alt=''
                />
              </a>
            </td>
            <td valign='middle'>
              <a href='https://www.youtube.com/cargill' style={{ marginLeft: "10px", marginRight: "10px" }}>
                <img
                  src='https://miappstorage.dev.cglcloud.in/api/miappstorage/v1/downloadImage/youtubeNew.png'
                  alt=''
                />
              </a>
            </td>
            <td valign='middle'>
              <a
                href='https://www.cargill.com/page/cargill-contact-us'
                style={{ marginLeft: "10px", marginRight: "10px" }}
              >
                <span>
                  <img
                    src='https://miappstorage.dev.cglcloud.in/api/miappstorage/v1/downloadImage/contactNew.png'
                    alt=''
                  />
                </span>
              </a>
            </td>
            <td valign='middle'>
              <div style={{ display: "inline-block" }}>
                <span
                  style={{
                    fontFamily: "'HelveticaNeueW01-75Bold', Helvetica, Arial, sans-serif",
                    fontWeight: "700",
                    color: "#cccccc",
                  }}
                >
                  {props.businessUnit !== BUSINESS_UNIT.GRAINS
                    ? "© 2024 Cargill,Incorporated. All Rights Reserved."
                    : "© 2024 Cargill France S.A.S. All Rights Reserved."}
                </span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <table
        align='center'
        width='800'
        style={{
          width: "800px",
          textAlign: "justify",
          borderCollapse: "separate",
          tableLayout: "'fixed'",
          fontFamily: "Helvetica, Arial, sans-serif",
        }}
      >
        <tbody>
          <tr>
            <td></td>
          </tr>
          <tr>
            <td></td>
          </tr>
          <tr>
            <td>
              <img src={props?.footerData?.footerImage || thriveImgSrc} width='800' alt='' />
            </td>
          </tr>
        </tbody>
      </table>
    </>
  );
}

export default Footer;
